export const FileStateType = {
	New: 'new',
	Uploading: 'uploading',
	Uploaded: 'uploaded',
	Error: 'error',
} as const;
export type FileStateType = (typeof FileStateType)[keyof typeof FileStateType];

/* -------------------------------------------------------------------------------------------------------------- */
export const FileStateIcon = {
	[FileStateType.New]: {class: 'fa-duotone fa-xl fa-badge', color: 'var(--dc-secondary)', iconName: 'badge', faStyle: 'duotone', size: 'xl'},
	[FileStateType.Uploading]: {class: 'fa-duotone fa-xl fa-badge fa-spin', color: 'var(--dc-info)', iconName: 'badge', faStyle: 'duotone', size: 'xl', animation: 'spin'},
	[FileStateType.Uploaded]: {class: 'fa-duotone fa-xl fa-badge-check', color: 'var(--dc-success)', iconName: 'badge-check', faStyle: 'duotone', size: 'xl'},
	[FileStateType.Error]: {class: 'fa-duotone fa-xl fa-badge-exclamation', color: 'var(--dc-danger)', iconName: 'badge-exclamation', faStyle: 'duotone', size: 'xl'},
} as const;
/* -------------------------------------------------------------------------------------------------------------- */
export type FileState = {
	state: FileStateType;
	icon: (typeof FileStateIcon)[keyof typeof FileStateIcon];
	progress?: number;
	error?: string;
};
